import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { getCollectionFirebase } from '../../Apis/firebaseApi';
import { Box, Flex, Heading, Stack, Text } from '@chakra-ui/react';

const PromptFileListPage = () => {
    const params = useParams();
    const [files, setFiles] = useState([]);
    const navigate = useNavigate();
    console.log(params, "params")

    const getFiles = async () => {
        try {
            const conditions = [{
                value: params?.id,
                operator: "==",
                field: "folderId"
            }]
            const result = await getCollectionFirebase('files', { conditions }, { sortBy: null }, { limitValue: null });
            console.log({ result });
            setFiles(result);
        } catch (error) {
            console.log(error.message, "----error when getting files");
        }
    };

    useEffect(() => {
        getFiles();
    }, [])


    return (
        <Box w="full" h="100vh">
            <Heading>File List Page</Heading>

            {files ? files?.map((item, index) => {
                return <Flex
                    _hover={{
                        transform: 'scale(1.04)',
                        transition: "60ms linear",
                    }}
                    onClick={() => navigate(item?.id, { state : item?.content})}
                    bg='white'
                    borderRadius="2xl"
                    shadow="sm"
                    cursor='pointer'
                    p={5} my={2} borderBottomWidth={2} borderBottomColor="rgba(0,0,0,0.1)" key={index} w="full">
                    <Stack>
                        <Heading size="sm">{item?.name}</Heading>
                        <Text>ID : {item?.id}</Text>
                        <Text>Type : {item?.type}</Text>
                    </Stack>
                </Flex>
            }) : null}

        </Box>
    )
}

export default PromptFileListPage;